:host {
  .events-news {
    &__header {
      background: var(--floating-panel-background, var(--bg-primary, #fff));
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      padding: 24px 16px 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        font-size: 14px;
        font-weight: 500;
        color: var(--font-primary);
        cursor: pointer;
        span {
          padding: 5px 9px;
          background: #ff8500;
          color: #fff;
          border-radius: 38px;
          margin-left: 8px;
          font-size: 12px;
        }
      }
      .all-read-link {
        font-size: 14px;
        font-weight: 400;
        color: var(--blue-link);
        cursor: pointer;
      }
    }

    &__button {
      padding-left: 16px;
      padding-right: 16px;
      button {
        width: 100%;
        height: 44px;
        border: 0;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        background-color: var(--bg-secondary-hover);
        color: var(--font-secondary);
        cursor: pointer;
        &:hover {
          color: var(--blue-link);
        }
      }
    }
  }
}
